module.exports = __webpack_public_path__ + "img/platform_logo.336a14eb.png";